import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=4768d222"
import script from "./Recibo.vue?vue&type=script&lang=ts"
export * from "./Recibo.vue?vue&type=script&lang=ts"
import style0 from "./Recibo.vue?vue&type=style&index=0&id=4768d222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports